import { Component, DestroyRef, inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ScreenType, SQWADService } from '@fgb/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'fgb-ace-jump-page',
  templateUrl: './ace-jump-page.component.html',
  styleUrl: './ace-jump-page.component.scss',
})
export class AceJumpPageComponent implements OnInit {
  screenType = ScreenType;
  jumpToSurviveURL: string;

  private destroyRef = inject(DestroyRef);
  @ViewChild('gameCallback') gameCallback: TemplateRef<any>;

  constructor(private sqwadService: SQWADService, private translate: TranslateService) {}

  ngOnInit(): void {
    this.jumpToSurviveLink();
  }

  launchGame(url: string) {
    this.sqwadService.sso(1, url);
  }

  jumpToSurviveLink() {
    this.translate
      .stream('jump.to.survive.url')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: string) => {
        this.jumpToSurviveURL = data;
      });
  }
}
